import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import ContactMenu from '../../components/menus/Contact';

const styles = css`
  background-color: #000000;
  .container {
    @media (max-width: 575.98px) {
      padding-left: 35px;
      padding-right: 35px;
    }
    @media (min-width: 1700px) {
      max-width: 1140px;
    }
  }
  .ThankYou_inner {
    padding: 52px 0 74px;
    @media (min-width: 768px) {
      padding: 60px 0 90px;
    }
    @media (min-width: 992px) {
      padding: 70px 0 110px;
    }
  }
  .ThankYou_header {
    font-size: 24px;
    font-weight: 600;
    letter-spacing: 0.02em;
    line-height: 1.151515;
    padding-bottom: 28px;
    margin-bottom: 23px;
    position: relative;
    @media (min-width: 768px) {
      font-size: 28px;
      padding-bottom: 22px;
      margin-bottom: 18px;
    }
    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 75px;
      height: 3px;
      background-color: #CDAB35;
    }
  }
  .ThankYou_copy {
    font-size: 16px;
    line-height: 2.0625;
    color: #484941;
    margin: 0;
    @media (min-width: 768px) {
      font-size: 20px;
      font-weight: 300;
      line-height: 1.863636;
    }
  }
`;

function ThankYou({ page }) {
  return (
    <PageWrapper className={styles}>
      <PageHelmet page={page} />
      <InsideHeader
        title="Thank You"
        background={get(page, 'page_image.contentUrl')}
      />
      <ContactMenu />
      <div className="container">
        <div className="row">
          <div className="ThankYou_inner">
            <h4 className="ThankYou_header">Thank You</h4>
            <p className="ThankYou_copy">
              We have recieved your message and will respond as soon as possible.
            </p>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}

ThankYou.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'contact_us',
})(ThankYou);



// WEBPACK FOOTER //
// ./src/pages/ContactUs/ThankYou.js